import { createAction } from '@reduxjs/toolkit';
import { storeName } from '../config';
import { UserManagementFilters } from '../interfaces';

export const changeFilter = createAction<{
  key: keyof UserManagementFilters;
  value: string | number | number[] | null;
}>(`${storeName}/changeFilter`);
